import React, { useState } from 'react';

const ProgressiveImage = ({
  src,
  optimizedSrc = '',
  optimizedSrcSet = '',
  alt,
  containerClassName = '',
  imgClassName = '',
  loading = 'lazy',
  decoding = 'async',
  fetchPriority = 'auto',
  sizes = '',
  width,
  height,
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative h-full w-full overflow-hidden ${containerClassName}`.trim()}>
      <div
        aria-hidden="true"
        className={`absolute inset-0 bg-gradient-to-br from-white/80 via-pink-100/70 to-sky-100/90 transition-opacity duration-500 ${
          loaded ? 'opacity-0' : 'animate-pulse opacity-100'
        }`}
      />
      <picture className="block h-full w-full">
        {optimizedSrc || optimizedSrcSet ? (
          <source
            srcSet={optimizedSrcSet || optimizedSrc}
            sizes={sizes || undefined}
            type="image/webp"
          />
        ) : null}
        <img
          src={src}
          alt={alt}
          loading={loading}
          decoding={decoding}
          fetchpriority={fetchPriority}
          width={width}
          height={height}
          onLoad={() => setLoaded(true)}
          className={`h-full w-full transition-opacity duration-500 ${
            loaded ? 'opacity-100' : 'opacity-0'
          } ${imgClassName}`.trim()}
        />
      </picture>
    </div>
  );
};

export default ProgressiveImage;
